var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.loading
        ? _c("loading-linear")
        : _c("div", {
            class: _vm.cssWrapper,
            attrs: { id: "contentParentModal" },
            domProps: { innerHTML: _vm._s(_vm.html) },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }